export const PLANNING_FEATURES = {
  moduleKey: 'planning',
  features: ['planning.plans', 'planning.plans.publish', 'planning.shifts.manage', 'planning.assignments', 'planning.rule-engine'] as const,
  featureMeta: {
    'planning.plans': {
      name: 'Plans',
      translations: { name: { de: 'Pläne', en: 'Plans', fr: 'Plans', it: 'Piani' } },
    },
    'planning.plans.publish': {
      name: 'Publish plans',
      translations: { name: { de: 'Pläne veröffentlichen', en: 'Publish plans', fr: 'Publier les plans', it: 'Pubblicare i piani' } },
    },
    'planning.shifts.manage': {
      name: 'Manage shifts',
      translations: { name: { de: 'Schichten verwalten', en: 'Manage shifts', fr: 'Gérer les shifts', it: 'Gestire i turni' } },
    },
    'planning.assignments': {
      name: 'Assignments',
      translations: { name: { de: 'Zuweisungen', en: 'Assignments', fr: 'Affectations', it: 'Assegnazioni' } },
    },
    'planning.rule-engine': {
      name: 'Planning rule engine',
      translations: {
        name: {
          de: 'Planungsregelwerk',
          en: 'Planning rule engine',
          fr: 'Moteur de règles de planification',
          it: 'Motore delle regole di pianificazione',
        },
      },
    },
  },
} as const;
